import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-icon-info-note-blank",
  "use": "svg-icon-info-note-blank-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"svg-icon-info-note-blank\"><path d=\"M17.678 14.81a9.605 9.605 0 10-3.344 3.155l3.18.852a.798.798 0 00.976-.978l-.812-3.03\" fill=\"#3AA9DF\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol